/**
 * [sc-48692] Che cosa scrivere alla voce «Indirizzo di consegna» del DDT.
 *
 * L'indirizzo dell'ordine non sempre è quello dell'anagrafica del cliente, e
 * su un ritiro non c'è nessun indirizzo da scrivere: il documento deve dirlo,
 * non lasciare «Non specificato», che sembra una dimenticanza.
 */
export const RITIRO_IN_SEDE = "Ritiro presso il magazzino";

export function indirizzoDdt({ indirizzo, deliveryType } = {}) {
  const scritto = typeof indirizzo === "string" ? indirizzo.trim() : "";
  if (scritto) return scritto;
  return deliveryType === "ritiro" ? RITIRO_IN_SEDE : "";
}
